package one.healthium.uscreen.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class UScreenTypography {
    @SerialName("quiz_title") Title,
    @SerialName("quiz_subtitle") Subtitle,
    @SerialName("quiz_body") Body,
    @SerialName("quiz_caption") Caption,
    @SerialName("quiz_emoji") Emoji,
}
